const calculateStockAmount = (data) => {
  if (!data) return 0;
  const amount = data.stock - data.reserved - data.low_stock;
  return amount > 0 ? amount : 0;
};

export { calculateStockAmount };
